import { goBack } from "./go-back.directive";
export default angular
  .module("common.libs.goBack", [])
  .directive("goBack", goBack).name;



// WEBPACK FOOTER //
// ./src/app/common/components/go-back/go-back.module.js